import { Viewport } from '@xyflow/react';
import { createContext } from 'react';

type ViewportContextType = {
  viewports: Record<string, Viewport>;
  setViewports: (viewports: Record<string, Viewport>) => void;
  centerOnNode: string | undefined;
  setCenterOnNode: (nodeId?: string) => void;
};

export const ViewportContext = createContext<ViewportContextType>({
  viewports: {},
  setViewports: () => {},
  centerOnNode: undefined,
  setCenterOnNode: () => {}
});
